<template>
    <el-dialog :visible="visible" @close="handleClose" :close-on-click-modal="false" class="ah-dialog currency-edit-dialog small-edit-dialog" center>
        <template slot="title">
            <p>{{ inputObject.cnynam }}</p>
            <p>{{ inputObject.cny }}</p>
        </template>
        <span>匯率</span>
        <el-input
            v-model.number="rat"
            placeholder="請輸入"
            @input="
                val => {
                    rat = val
                        .replace(/[^0-9.]/g, '')
                        .replace('.', '#*')
                        .replace(/\./g, '')
                        .replace('#*', '.');
                }
            "
            @keyup.enter.native="handleInputEnter"
        ></el-input>
        <span slot="footer" class="dialog-footer">
            <el-row :gutter="20">
                <el-col :span="8">
                    <el-button @click="handleClose" style="width: 100%">取 消</el-button>
                </el-col>
                <el-col :span="16">
                    <el-button type="primary" @click="event => handleClose(event, true)" style="width: 100%">儲 存</el-button>
                </el-col>
            </el-row>
        </span>
    </el-dialog>
</template>
<script>
export default {
    props: {
        visible: {
            type: Boolean,
            default: false,
        },
        inputObject: {
            type: Object,
            default: null,
        },
    },
    created() {
        if (this.inputObject) {
            this.rat = JSON.parse(JSON.stringify(this.inputObject.rat));
        }
    },
    data() {
        return {
            rat: '',
        };
    },
    methods: {
        handleClose(event, refresh = false) {
            this.$emit('close', refresh ? parseFloat(this.rat) : '');
        },
        handleInputEnter() {
            this.$emit('close', parseFloat(this.rat));
        },
    },
};
</script>
<style lang="scss">
.currency-edit-dialog {
    .el-dialog {
        .el-dialog__header {
            padding-top: 35px;
            text-align: center;
            font-size: 15pt;
        }

        .el-dialog__body {
            padding-top: 10px;
        }
    }
}
</style>
